export default __webpack_public_path__ + "static/stefan-6d0f6da09123e05fc209bb168babfaf0.jpg";